import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=2c1e59b6&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c1e59b6')) {
      api.createRecord('2c1e59b6', component.options)
    } else {
      api.reload('2c1e59b6', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=2c1e59b6&", function () {
      api.rerender('2c1e59b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2n937v0qYSzQl/JS/cancellationPolicy.vue"
export default component.exports